// store.js
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducers"; // or create slices and combine if needed

// Load persisted state from localStorage
const loadState = () => {
  try {
    const serializedState = localStorage.getItem("state");
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (e) {
    return undefined;
  }
};

// Save state to localStorage
const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("state", serializedState);
  } catch (e) {
    // Ignore write errors
  }
};

const persistedState = loadState();

// Create store with Redux Toolkit
const store = configureStore({
  reducer: rootReducer,
  preloadedState: persistedState,
  // middleware: getDefaultMiddleware => getDefaultMiddleware() // No need to add thunk — included by default
});

// Save state to localStorage on change
store.subscribe(() => {
  saveState(store.getState());
});

export default store;
